/*
vue项目版本打包更新后文件及浏览器存在缓存问题解决方案
*/


import Vue from 'vue'
import axios from "@/http/axios"
import { Message } from 'element-ui';

function isBlank (value) {
  if (value === "" || value === null || value === undefined) { // "",null,undefined
    return true;
  } else {
    return false;
  }
}
async function updateConfig () {
  // 更新缓存文件
  const data = await axios({
    url: `/static/config.json`,
    type: "GET"
  })
  for (let key in data) {
    Vue.prototype[key] = data[key]
  }
}
const isNewVersion = async (isShowMessage = true) => {
  // 当前版本号
  // 更新配置文件，判断是否更新
  await updateConfig()
  const vueVersion = Vue.prototype.version
  let localVueVersion = localStorage.getItem('vueVersion');
  // 没有版本号的版本需要更新，两个版本不相同也需要更新
  if (localVueVersion != vueVersion || !localVueVersion && !vueVersion) {
    if (isShowMessage) {
      Vue.prototype.$confirm(
        '发现新版本，您确定现在更新吗？', '提示', {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: 'warning'
      }
      ).then(() => {
        // 设置当前版本号，重新加载
        localStorage.setItem('vueVersion', vueVersion);
        window.location.reload(true);
      })
    } else {
      // 设置当前版本号，重新加载
      localStorage.setItem('vueVersion', vueVersion);
      window.location.reload(true);
    }
    return;
  }
  isShowMessage && Message.info('当前已是最新版本')
  console.log('无需更新', vueVersion, localVueVersion);
}

export default {
  isNewVersion,
  updateConfig
}



// WEBPACK FOOTER //
// ./src/utils/versionUpdate.js